module.exports = __webpack_public_path__ + "img/covericon01.e4d9e78b.png";